import { MobileCarouselTabs } from 'lib/mobileDesignSystem';
import React from 'react';

import { CREDIT_LINE_TABS } from './tabConfig';

const CreditLineTabsView: React.FC = () => (
  <MobileCarouselTabs items={CREDIT_LINE_TABS} />
);

export default CreditLineTabsView;
